import React, { useEffect, useState } from "react";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { getFilterTitleStyle } from "../utils";
import { minusSvg, plusSvg } from "../svg/svgList";
import { COMMON_LAYOUT_TYPE } from "../../ListPresentation/components/Testimonials/Constants";
import contentAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss';

function Accordian(props) {
  const { text, styleComp, layoutType, handleElementClick, selectedElement, selectedFilterInfo } = props;
  const isMobile = isMobileDevice();
  const isLayout2 = layoutType === COMMON_LAYOUT_TYPE.TWO && !isMobile;
  const { keep_filters_open, title_color } = styleComp?.sortAndFilter || {};
  const [showChild, setShowChild] = useState(isLayout2 ? false : keep_filters_open);
  const showChildElement = isLayout2 ? (showChild && selectedElement === text) : showChild
  useEffect(() => {
    if (!isLayout2) {
      setShowChild(keep_filters_open)
    }
  }, [keep_filters_open])
  function handleAccordian() {
    setShowChild(!showChild);
    if (isLayout2)
      handleElementClick?.(text)
  }
  return (
    <div className={`tw-flex tw-flex-col tw-gap-[16px] tw-relative ${!isLayout2 ? 'tw-w-[100%]' : ''} `}>
      <div style={{ ...getFilterTitleStyle(styleComp, isMobile) }} onClick={handleAccordian}
        className={`tw-flex tw-cursor-pointer tw-items-center ${!isLayout2 ? 'tw-justify-between' : 'tw-gap-[4px] tw-p-[5px] hover:tw-bg-[#171C2A0D]'} `}>
        <div className="tw-flex tw-items-center tw-gap-[2px]">
          <div className="">{text}</div>
          {selectedFilterInfo[text]?.length > 0 && <div>{`(${selectedFilterInfo[text]?.length})`}</div>}
        </div>
        {!isLayout2 && <div>
          {showChildElement && <div >{minusSvg(title_color)}</div>}
          {!showChildElement && <div >{plusSvg(title_color)}</div>}
        </div>}
        {
          isLayout2 &&
          <div>
            {!showChildElement && <div className="wb-sprite ic-arrow-down"></div>}
            {showChildElement && <div className="wb-sprite ic-arrow-down inverted"></div>}
          </div>
        }
      </div>
      {showChildElement && <div className={`
        ${isLayout2 ? ` ${contentAnimationStyle['widgetContentMoveDownWrapper']} tw-border tw-border-solid tw-border-[#111C3629] tw-bg-white
           tw-absolute tw-bottom-0 tw-top-[30px] tw-p-[24px] tw-z-[100] tw-h-max tw-max-h-[350px] tw-w-max tw-min-w-[150px] tw-max-w-[300px] tw-overflow-scroll` :
          ''}`}>{props.children}</div>}
      {!isLayout2 && <div style={{ borderBottom: '1px solid #111c3629' }}></div>}
    </div>
  )
}

export default Accordian

